import { useContext } from 'react';

import {
  Button,
  ListItem,
} from '@mui/material';
import { NavLink as RouterLink } from 'react-router-dom';
import { SidebarContext } from 'src/contexts/SidebarContext';

import MovieIcon from '@mui/icons-material/Movie';
import { LocalizationContext } from 'src/contexts/LocalizationContext';

interface SidebarTutorialItemProps {
  groupQuestionId: number;
}
function SidebarTutorialItem(props: SidebarTutorialItemProps) {
  const { strings } = useContext(LocalizationContext);
  const { closeSidebar } = useContext(SidebarContext);

  const { groupQuestionId } = props;
  
  return (
    <ListItem component="div">
      <Button
        disableRipple
        component={RouterLink}
        onClick={closeSidebar}
        to={`/tutorial/${groupQuestionId}`}
        startIcon={<MovieIcon />}
      >
        {strings.questionsGroup[`questionGroup${groupQuestionId.toString()}`]}
      </Button>
    </ListItem>
  );
}

export default SidebarTutorialItem;
